import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    id: '',
    email: '',
    name: '',
    accessToken: '',
    keepLogged: false,
};
const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        setAuth(state, action) {
            const { email, name, accessToken, id, keepLogged } = action.payload;
            if (email !== undefined)
                state.email = email;
            if (name !== undefined)
                state.name = name;
            if (accessToken !== undefined)
                state.accessToken = accessToken;
            if (id !== undefined)
                state.id = id;
            if (keepLogged !== undefined)
                state.keepLogged = keepLogged;
        },
        logout: (state) => {
            state.id = '';
            state.name = '';
            state.email = '';
            state.accessToken = '';
            state.keepLogged = false;
            localStorage.removeItem('authState');
        },
        updateEmail(state, action) {
            state.email = action.payload;
        },
    },
});
export const { setAuth, logout, updateEmail } = authSlice.actions;
export const selectIsAuth = (state) => Boolean(state.auth.accessToken);
export default authSlice.reducer;
